import { defineMessages } from 'react-intl';

export default defineMessages({
  ErrorMessageHeader: {
    id: 'Apply.Error.Header',
    defaultMessage: 'An error has occurred',
  },
  ErrorMessage: {
    id: 'Apply.Error.Message',
    defaultMessage: 'The website encountered an unexpected error. Please try again later.',
  },
});
